import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { FormAccordion } from '@strata/react-form-section';

import {
    type FormSection,
    FormSections,
    InitialIntakeFormValues,
    type IntakeFormSchema,
    type IntakeFormSectionStatus,
    type IntakeFormStatus,
} from 'store/intakeForm/intakeFormSchema';

// Set up initial form state
const initSections = () => {
    const sections: Partial<IntakeFormStatus> = {};
    Object.values(FormSections).forEach((section) => {
        sections[section] = {
            progressIndicatorStatus:
                section === 1 ? FormAccordion.statuses.ACTIVE : FormAccordion.statuses.NOT_STARTED,
            isOpen: section === 1,
        };
    });
    return sections as IntakeFormStatus;
};

const initialState = {
    capturedData: InitialIntakeFormValues,
    sections: initSections(),
    activeSection: 1,
};

export const intakeFormSlice = createSlice({
    name: 'intakeForm',
    initialState,
    reducers: {
        resetState() {
            return initialState;
        },
        updateActiveSection(state, action: PayloadAction<FormSection>) {
            return {
                ...state,
                activeSection: action.payload,
            };
        },
        updateCapturedData(state, action: PayloadAction<Partial<IntakeFormSchema>>) {
            return {
                ...state,
                capturedData: {
                    ...state.capturedData,
                    ...action.payload,
                },
            };
        },
        updateSectionStatus(
            state,
            action: PayloadAction<{
                section: FormSection;
                sectionStatus: IntakeFormSectionStatus;
            }>,
        ) {
            return {
                ...state,
                sections: {
                    ...state.sections,
                    [action.payload.section]: {
                        ...state.sections[action.payload.section],
                        ...action.payload.sectionStatus,
                    },
                },
            };
        },
    },
});

export const { resetState, updateActiveSection, updateCapturedData, updateSectionStatus } =
    intakeFormSlice.actions;
